import { AbilityBuilder, createMongoAbility } from "@casl/ability";
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
  if (user) {
    const permissoes = user.todasPermissoes;
    can("read", "BIBLIOTECA");
    can('read', 'PERFIL')
    if (user.temPermissao(["admin_biblioteca"])) {
      can("manage", "Diretorio");
    }
    can("manage", "Diretorio", {
      "acesso.full": { $in: permissoes },
    });
    can(["read", "upload", "novaPasta"], "Diretorio", {
      "acesso.full": { $exists: false },
    });
    can("read", "Diretorio", {
      "acesso.rOnly": { $in: permissoes },
    });
    can(["read", "upload"], "Diretorio", {
      "acesso.uploadOnly": { $in: permissoes },
    });
    can(["read", "editar", "upload", "novaPasta", "delete"], "Diretorio", {
      "acesso.rW": { $in: permissoes },
    });
    can(
      ["read", "editar", "gerenciar", "upload", "novaPasta", "delete"],
      "Diretorio",
      {
        "acesso.rWEdit": { $in: permissoes },
      }
    );
  }
  return build();
}
